import { ChangeEvent } from "react";
import { Switch } from "@mui/material";
import { SETTING_WAIT_TIME_NUMBER_GROUPS } from "../../constants";
import { ClinicSetting } from "../../models";
import { InputNumber, InputText } from "../Common";
import { WaitTimeGroupsTable } from "./WaitTimeGroupsTable";

interface ClinicSettingsTableProps {
	settings: ClinicSetting[];
	errors?: string[];
	onSettingChange: (event: ChangeEvent<HTMLInputElement>) => Promise<void>;
	onWaitTimeGroupChange: (event: ChangeEvent<HTMLInputElement>) => Promise<void>;
}

const renderSettingControl = (
	setting: ClinicSetting,
	onSettingChange: (event: ChangeEvent<HTMLInputElement>) => Promise<void>,
	onWaitTimeGroupChange: (event: ChangeEvent<HTMLInputElement>) => Promise<void>
) => {
	if (setting.dataType === "boolean") {
		return (
			<Switch
				checked={setting.value === "1"}
				onChange={onSettingChange}
				name={setting.settingName}
			/>
		);
	}

	if (setting.dataType === "number") {
		return (
			<InputNumber
				value={setting.value || ""}
				name={setting.settingName}
				handleChange={onSettingChange}
				min={0}
				width={100}
			/>
		);
	}

	if (setting.settingName === SETTING_WAIT_TIME_NUMBER_GROUPS) {
		return (
			<WaitTimeGroupsTable
				settingValue={setting.value}
				onChange={onWaitTimeGroupChange}
			/>
		);
	}

	return (
		<InputText
			value={setting.value}
			name={setting.settingName}
			handleChange={onSettingChange}
			width={400}
		/>
	);
};

export const ClinicSettingsTable = ({
	settings,
	errors,
	onSettingChange,
	onWaitTimeGroupChange
}: ClinicSettingsTableProps) => (
	<div className="w-full overflow-x-auto">
		<table className="ch-table w-full border-collapse">
			<thead>
				<tr>
					<th>Value</th>
					<th>Description</th>
				</tr>
			</thead>
			<tbody>
				{settings.map((setting) => (
					<tr key={`setting-${setting.clinicId}-${setting.settingId}`}>
						<td>
							{renderSettingControl(
								setting,
								onSettingChange,
								onWaitTimeGroupChange
							)}
						</td>
						<td>
							{setting.settingDescription}
							{setting.settingName === SETTING_WAIT_TIME_NUMBER_GROUPS &&
								errors?.map((error, index) => (
									<div key={`error-${index}`} className="error">
										{error}
									</div>
								))}
						</td>
					</tr>
				))}
			</tbody>
		</table>
	</div>
);
